import styled from 'styled-components';
import {colors, devices} from '../../utils/styled/_variables.styled';
import {InfiosInput, InfiosInputIconWrapper, InfiosInputWrapper} from '../FormComponents/Input/Input.style';
import {InfiosContainer} from '../../utils/styled/_grid.style';
import {InfiosLink} from '../Link/Link.style';

export const InfiosSearchNavigation = styled.section`
    .suggestions-wrapper {
        position: relative;
        display: flex;
        flex-direction: column;
        width: 100%;
    }

		.label-medium{
			font-size:19px;
		}

    ${props => props.isMobile && `
        width: 100%;
        margin-bottom: 48px;
    `}

    .search {
        ${props => !props.isMobile && `
            margin-top: 4px;
            margin-left: ${props.fullVersion ? "auto" : "11px"};
        `}
    }
`;

export const InfiosSearchSuggestions = styled.nav`
    display: flex;
    flex-direction: column;
    margin-top: 72px;

    span {
        margin-top: ${props => props.headerVersion ? "56px" : "0"};
    }

    ul {
        display: flex;
        flex-direction: column;
        list-style: none;
        align-items: flex-start;
        height: ${props => props.headerVersion ? "100vh" : "auto"};

        li {
            ${InfiosLink} {
            display: flex;
            justify-content: flex-start;
            margin-top: 24px;

            @media ${devices.mobile} {
                max-width: 100%;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }

            & + ${InfiosLink} {
                margin-top: 16px;
            }

            &:hover {
                color: ${colors.blueHover};
                .search {
                    path {
                        fill: ${colors.blueHover};
                    }
                }
            }

            &:active {
                color: ${colors.bluePressed};

                .search {
                    path {
                        fill: ${colors.bluePressed};
                    }
                }
            }

            .search {
                display: flex;
                text-align: left;
                margin: 0 11px 0 0;

                ${props => !props.isMobile && `
                	margin-left: ${props.fullVersion ? "auto" : "18px"};
                `}

                &-link {
                    display: flex;
                    align-items: center;

                    &__text {
                        @media ${devices.mobile} {
                            max-width: 50%;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                        }
                    }
                }
            }
        }
        }

    .search-container-link {
                &:hover {
                    svg {
                        transform: none;
                    }
                }
            }

}
`;



export const InfiosSearchWrapper = styled.div`
    display: flex;
    flex-direction: column-reverse;
    padding-bottom: 7px;

    &.search-component {
        ${props => !props.isMobile && `
            max-width: ${props.isFullWidth ? "100%" : "870px"} !important;
            margin: 7px auto 0;
        `}
    }

    ${InfiosContainer} {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        height: 100%;
        max-height: 542px;
        background-color: ${colors.white};
        z-index: 500;
        padding: 144px 0 0;

        .close {
            position: absolute;
            width: 40px;
            height: 40px;
            top: 32px;
            right: 96px;
            padding: 0;
            z-index: 1;
            background-color: ${colors.white};

            svg {
                width: 24px;
                height: 24px;
                margin: 0;

                path {
                    fill: ${colors.infiosGray};
                }
            }
        }
    }

    ${InfiosInputWrapper} {
        width: 100%;

        ${InfiosInput} {
            padding: 8px 48px 8px 16px;
            border: 0;
            height: 48px;
            background-color: ${colors.gray1};

            ${props => props.isMobile && `
                padding: 16px 48px 16px 20px;
                height: 64px;
            `}

            ${props => !props.isMobile && `
                padding: 16px 48px 16px 24px;
                height: 72px;
            `}
        }
    }

    ${InfiosInputIconWrapper} {
        top: 50%;
        right: 19px;
        pointer-events: ${props => props.icon != "cancel" ? "none" : "initial"};
        cursor: ${props => props.icon != "cancel" ? "default" : "pointer"};

        svg {
            height: 18px;
            width: 18px;
        }
    }

    ${InfiosSearchNavigation} {
        .search {
            cursor: pointer;
        }

        &:hover {
            .search {
                path {
                    fill: ${colors.blueHover};
                }
            }
        }

        &:active {
            .search {
                path {
                    fill: ${colors.bluePressed};
                }
            }
        }
    }

    ${props => props.isMobile && `
        width: 100%;
    `}
`;
